import React, { useState, useEffect, useCallback } from 'react'
import * as Yup from 'yup'
import moment from 'moment'
import { Formik, Form } from 'formik'
import { useSelector, useDispatch } from 'react-redux'
import { useModal } from 'react-modal-hook'
import Modal from '../../../components/Modal/Modal'
import PaymentsService from '../../../services/payments.service'
import InputError from '../../../components/InputError/InputError'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoInput from '../../../components/NeoInput/NeoInput'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import { useHistory, useLocation } from 'react-router-dom'
import DashboardService from '../../../services/dashboard.service'
import { setAccRefresh, setRemarks } from '../../../actions'
import NumberFormat from 'react-number-format'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import NeoLoader from '../../../components/FormComponents/NeoLoader'
import AccountDisplay from '../../../components/account-display/account-display'
import TermsAndConditions from '../../../components/TermsAndConditions/TermsAndCondition'
import {
  getFeatureListSelector,
  remarksSelector,
  carouselCurrentItemSelector,
} from '../../../selectors'
import { useTranslation } from 'react-i18next'
import {
  DIALOG_KEYS,
  VALIDATION_MESSAGES,
  DEPOSITS_KEYS,
  SIDENAV_KEYS,
  PAYMENT_KEYS,
} from '../../../utils/translation-constants'
import validationConfig from 'custom/config/validation.config.json'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
const bankToWalletConfig = validationConfig['bankToWallet']

export default function BillerProductForm() {
  const location = useLocation()
  const [selectedBiller, setSelectedBiller] = useState({})
  const [selectedProduct, setSelectedProduct] = useState({})
  const [quoteDetails, setQuoteDetails] = useState({})
  const [productDetails, setProductDetails] = useState({ products: [] })
  const history = useHistory()
  const dispatch = useDispatch()
  const [otp, setOTP] = useState('')
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const srcAccountDetails = useSelector(carouselCurrentItemSelector)
  const [message, setMessage] = useState('Error Placeholder')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [remarksList, setRemarksList] = useState([])
  const remarks = useSelector(remarksSelector)
  const [error, setError] = useState({})
  const featureList = useSelector(getFeatureListSelector)
  const { t } = useTranslation()
  const [data, setData] = useState({})
  const [successResponse, setSuccessResponse] = useState({})

  const LABELS = {
    BANKTOWALLET: t(PAYMENT_KEYS.MOBILE_NO),
  }

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{error?.message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    location.pathname.includes('/beneficiary-transfers') && setData({url:'/beneficiary-transfers', breadCrumb:'TRANSFERS_QUICK_PAY_SERVICE_FORM'})
    location.pathname.includes('/accounts') && setData({url:'/accounts', breadCrumb:'ACCOUNTS_QUICK_PAY_SERVICE_FORM'})
    if (location.state === undefined) {
      history.push(`${data.url}/quick-pay`)
      return
    }
    setSelectedBiller(location?.state?.serviceDetails)
    getProductDetails()
  }, [])

  const getProductDetails = useCallback(async () => {
    try {
      const { serviceDetails } = location?.state
      setLoading(true)
      const response = await PaymentsService.getServiceById({
        fetchProducts: true,
        serviceId: serviceDetails.serviceId,
      })
      if (response.status === 200) {
        setProductDetails(response.data)
        setLoading(false)
      }
    } catch (err) {
      setMessage(err)
    }
  }, [])

  const setSelectedProductCallback = useCallback(
    (data) => {
      const selectedProductFull = productDetails.products.find(
        (value) => value.description === data,
      )
      setSelectedProduct(selectedProductFull)
    },
    [productDetails],
  )

  const submitPayment = useCallback(
    async (data, { setSubmitting }) => {
      const featureDetails = featureList['BILL_PAY']
      if (featureDetails[srcAccountDetails['accountType']] === 'N') {
        setMessage({
          code: t(DIALOG_KEYS.NO_ACCESS),
          message: t(DIALOG_KEYS.NO_ACCOUNTS),
        })
        showModal()
        return
      }
      setLoading(true)
      setSubmitting(true)
      setFormValues(data)
      try {
        const response = await PaymentsService.getBillQuote({
          amount: data.debitAmount,
          srcAccBranch: srcAccountDetails.brnCode,
          merchant: productDetails.merchantId || productDetails.description,
          productId: selectedProduct?.productId || '',
          serviceId: productDetails.serviceId,
          serviceNumber: data.serviceNumber,
          srcAccount: srcAccountDetails.accountNo,
          isFixed: selectedProduct?.amountType == 'FIXED' ? true : false,
          voucherType: selectedProduct?.name || '',
          customerName: '',
          isScheduled: data.isScheduled === 'Yes' ? 'Y' : 'N',
          scheduledDate: data.scheduledDate,
        })
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnable'])
          setQuoteDetails(response.data['quote'])
          setStage(2)
        }
      } catch (err) {
        setMessage(err)
      }
      setSubmitting(false)
      setLoading(false)
    },
    [selectedProduct, srcAccountDetails, featureList, productDetails],
  )

  const confirmPayment = useCallback(async () => {
    setLoading(true)
    try {
      const response = await PaymentsService.payBill({
        amount: formValues.debitAmount,
        merchant: productDetails?.merchantId || productDetails.description,
        productId: selectedProduct?.productId || '',
        remarks: formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks,
        serviceId: productDetails?.serviceId,
        serviceType: '',
        serviceNumber: formValues.serviceNumber,
        srcAccount: srcAccountDetails.accountNo,
        srcAccCcy: srcAccountDetails.currency,
        srcAccBranch: srcAccountDetails.brnCode,
        voucherType: selectedProduct?.name || '',
        quoteId: quoteDetails['quoteId'],
        customerAddress: quoteDetails['customerAddress'] || '',
        senderName: quoteDetails['customerName'] || '',
        otp: otp,
        isScheduled: formValues.isScheduled === 'Yes' ? 'Y' : 'N',
        scheduledDate: formValues.scheduledDate || null,
        // customerName: '',
        cdf: {},
      })
      if (response.status === 200) {
        if (formValues.isScheduled === 'No') {
          dispatch(setAccRefresh(true))
        }
        setSuccessResponse(response.data)
        setMessage(
          formValues.isScheduled === 'No'
            ? response.data['message']
            : response.data['responseMessage'],
        )
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      // setMessage(
      //   err.errors === undefined || null ? err.message : err.errors && err.errors.join('\n'),
      // )
      setLoading(false)
    }
    setLoading(false)
  }, [productDetails, selectedProduct, formValues, otp, srcAccountDetails, quoteDetails])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderPaymentForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOTP} onSubmit={confirmPayment} loading={loading} />
      case 4:
        return <NeoSuccess
          onClick1={() =>
            BeneficiaryTransferService.downLoadReport({
              transRefNum: successResponse?.referenceNo,
              receiptNo:  successResponse?.receiptNo,
              refId: '',
              module: 'FUNDTRANSFER',
            })}
          module='DOWNLOAD_RECEIPT'
          message={message}
          linkPath={`${data.url}/quick-pay`} />
      default:
        return renderPaymentForm()
    }
  }

  const ProductPaymentFormSchema = Yup.object().shape({
    serviceNumber: Yup.string().required(
      `${LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)} ${t(
        PAYMENT_KEYS.IS_REQUIRED,
      )}`,
    ),
    amount: Yup.string().required(t(VALIDATION_MESSAGES.AMOUNT)),
    // .max(selectedAccountBalance, 'Insufficient Balance in selected account'),
    remarks: Yup.string().required(t(VALIDATION_MESSAGES.REMARK)),
    product:
      productDetails.products.length > 0
        ? Yup.string().required(t(VALIDATION_MESSAGES.PRODUCT))
        : Yup.string().optional(),
    customRemarks: Yup.string().when('remarks', {
      is: 'Custom',
      then: Yup.string().required(t(VALIDATION_MESSAGES.CUSTOM_REMARKS)),
      otherwise: Yup.string().optional(),
    }),
    isScheduled: Yup.string().required(t(VALIDATION_MESSAGES.SCHEDULE_PAYMENT)),
    scheduledDate: Yup.string().when('isScheduled', {
      is: 'Yes',
      then: Yup.string().required(t(VALIDATION_MESSAGES.SCHEDULE_DATE)),
      otherwise: Yup.string().optional(),
    }),
  })

  function renderPaymentForm() {
    console.log(selectedProduct)
    return (
      <div className=''>
        <AccountDisplay currentAccountDetail={srcAccountDetails} />
        {/* <div className='text-right'>
          <span style={{ color: 'red', fontSize: 10 }}>Note: All Bill Payments to be in ZWM</span>
        </div> */}
        <Formik
          enableReinitialize
          initialValues={{
            serviceNumber: '',
            amount: selectedProduct ? selectedProduct?.productAmount || '' : '',
            product: selectedProduct ? selectedProduct?.description || '' : '',
            remarks: '',
            serviceNumberBen: '',
            showBen: false,
            customRemarks: '',
            isScheduled: 'No',
            scheduledDate: '',
          }}
          validationSchema={ProductPaymentFormSchema}
          onSubmit={submitPayment}>
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue }) => (
            <Form>
              <div>
                {productDetails.products.length > 0 && (
                  <div className='row'>
                    <div className='form-group col-12'>
                      <NeoInput
                        tabIndex='1'
                        text={t(PAYMENT_KEYS.PRODUCT)}
                        showAsterisk={bankToWalletConfig["isProductRequired"]}
                        mode='select'
                        name='product'
                        onChange={(e) => {
                          setSelectedProductCallback(e.target.value)
                          handleChange(e)
                          setFieldValue('amount', '')
                        }}
                        list={productDetails.products}
                        keyValue='description'
                      />
                      <InputError text={errors.product} touched={touched.product} />
                    </div>
                  </div>
                )}

                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='2'
                      showAsterisk={bankToWalletConfig["isMobileNoRequired"]}
                      text={LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
                      onChange={handleChange}
                      name='serviceNumber'
                      value={values.serviceNumber}
                    />
                    <InputError text={errors.serviceNumber} touched={touched.serviceNumber} />
                  </div>

                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='3'
                      showAsterisk={bankToWalletConfig["isAmountRequired"]}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.AMOUNT)}
                      name='amount'
                      onChange={(values) => {
                        setFieldValue('debitAmount', values.value)
                      }}
                      mode='amount'
                      value={values.amount}
                      disabled={selectedProduct.amountType === 'FIXED'}
                    />
                    <InputError text={errors.amount} touched={touched.amount} />
                  </div>
                </div>

                <div className='mt-3 form-group'>
                  <NeoInput
                    tabIndex='4'
                    showAsterisk={bankToWalletConfig["isSchedulePaymentRequired"]}
                    text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_PAYMENT)}
                    mode='select'
                    name='isScheduled'
                    onChange={(e) => {
                      handleChange(e)
                    }}
                    list={['Yes', 'No']}
                    keyValue={null}
                  />
                  <InputError text={errors.isScheduled} touched={touched.isScheduled} />
                </div>

                {values.isScheduled === 'Yes' && (
                  <div className='form-group mt-3'>
                    <NeoInput
                      tabIndex='5'
                      showAsterisk={bankToWalletConfig["isScheduleDateRequired"]}
                      name='scheduledDate'
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE)}
                      icon='calendar_today'
                      mode='single'
                      type='date'
                      onChange={handleChange}
                      min={moment(new Date()).format('YYYY-MM-DD')}
                    />
                    <InputError text={errors.scheduledDate} touched={touched.scheduledDate} />
                  </div>
                )}
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='6'
                      showAsterisk={bankToWalletConfig["isRemarksRequired"]}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.REMARKS)}
                      onChange={handleChange}
                      name='remarks'
                    />
                    <InputError text={errors.remarks} touched={touched.remarks} />
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {values.remarks === 'Custom' && (
                      <>
                        <NeoInput
                          tabIndex='7'
                          text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CUSTOM_REMARK)}
                          onChange={handleChange}
                          name='customRemarks'
                        />
                        <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                      </>
                    )}
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {isSubmitting ? (
                      <NeoLoader />
                    ) : (
                      <NeoButton
                        tabIndex='8'
                        type='submit'
                        mode='newDesign'
                        disabled={isSubmitting}
                        text={t(PAYMENT_KEYS.SUBMIT)}
                      />
                    )}
                  </div>
                </div>
                <div className='back-cancel-btn-container'>
                <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'9'} onClick={() => history.push(`${data.url}/quick-pay`)}>
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div>
        <div className='d-flex flex-column confirmation'>
          <AccountDisplay currentAccountDetail={srcAccountDetails} />

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.BILLER_NAME)}</h6>
            <h6 className='value'>{selectedBiller?.description}</h6>
          </div>

          <div>
            <h6 className='label'>
              {LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
            </h6>
            <h6 className='value'>{formValues?.serviceNumber}</h6>
          </div>
          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.QUOTE_ID)}</h6>
            <h6 className='value'>{quoteDetails['quoteId']}</h6>
          </div>
          <div>
            <h6 className='label'>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.CUSTOMERNAME)}</h6>
            <h6 className='value'>{quoteDetails['customerName'] || '-'}</h6>
          </div>

          <div>
            <h6 className='label'>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.CUSTOMER_ADDRESS)}</h6>
            <h6 className='value'>{quoteDetails['customerAddress'] || '-'}</h6>
          </div>

          <div>
            <h6 className='label'>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.AMOUNT_DUE)}</h6>
            <h6 className='value'>{quoteDetails['amountDue'] || '0.00'}</h6>
          </div>

          <div>
            <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.AMOUNT_DETAILS)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={formValues?.debitAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
              />
            </h6>
          </div>

          <div>
            <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_PAYMENT2)}</h6>
            <h6 className='value'>{formValues?.isScheduled}</h6>
          </div>

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.REMARK)}</h6>
            <h6 className='value'>
              {formValues?.remarks === 'Custom' ? formValues?.customRemarks : formValues?.remarks}
            </h6>
          </div>

          <div>
            <TermsAndConditions module="BANKTOWALLET" />
          </div>
          <div className='mt-3 form-group col-12'>
            {loading ? (
              <NeoLoader />
            ) : (
              <NeoButton
                type='button'
                text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CONFIRM_BUTTON)}
                mode='newDesign'
                onClick={async () => {
                  otpEnabled ? setStage(3) : await confirmPayment()
                }}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
          </div>
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
    pageTitle={`${selectedBiller?.category} - ${selectedBiller?.description}`}
     breadCumKey={data.breadCrumb}>
      <div className='new-design-form-style'>
        <div className='heading-style'>
          {selectedBiller?.merchantId}- {selectedBiller?.description}
        </div>
        {renderSwitch()}
      </div>
    </LayoutWithAccountCard>
  )
}
